import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { APP_NAME } from '../../config/branding';

interface PaywallModalProps {
    isOpen: boolean;
    practiceName?: string;
}

const PaywallModal: React.FC<PaywallModalProps> = ({ isOpen }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] overflow-y-auto">
            <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity z-[9998]" aria-hidden="true"></div>

            <div className="flex min-h-screen items-center justify-center p-4 relative z-[9999]">
                <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full p-8 text-center">
                    <div className="mx-auto w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                        <Mail className="w-8 h-8 text-blue-600" />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 mb-3">
                        Get Started with {APP_NAME}
                    </h2>

                    <p className="text-gray-600 mb-8">
                        Your account hasn't been activated yet. Contact our sales team to get set up and start transforming your practice with AI.
                    </p>

                    <a
                        href="mailto:hi@helppet.ai?subject=Activate%20my%20account"
                        className="w-full bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors mb-3 flex items-center justify-center"
                    >
                        <Mail className="w-4 h-4 mr-2" />
                        Contact Sales
                    </a>

                    <a
                        href="tel:+14255841920"
                        className="w-full bg-white text-gray-700 font-semibold py-3 px-6 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors mb-3 flex items-center justify-center"
                    >
                        <Phone className="w-4 h-4 mr-2" />
                        (419) 283-1624
                    </a>

                    <button
                        onClick={() => window.location.href = '/'}
                        className="w-full text-gray-500 font-medium py-2 px-6 hover:text-gray-700 transition-colors text-sm"
                    >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaywallModal;
